import esriConfig from '@arcgis/core/config';
import { useEffect, useState } from 'react';
import WebFont from 'webfontloader';
import { loadPortalItem } from '../arcgis/jsapi/js-api-util';

const defaults: any = {
    activeTool: 0,
    autoSelectLayers: true, // DEPRECATED
    displayLegendTool: true,
    displayWelcomePanel: true,
    fontFamily: 'Avenir Next',
    fontSize: 16,
    fieldFilterList: '', //'UTLAName,MSOAName,WardName',
    layerIndex: 0,
    mastertable: undefined,
    maxFeatures: 10,
    linkTarget: '_blank', // DEPRECATED
    reportLinkButtonText: '', // DEPRECATED.
    reportSelectionMode: '_blank', // DEPRECATED Hardcoded to _blank.
    reportUrlPattern: '', // Default value of "https://reports.instantatlas.com/view-report/",
    selectToolBox: true,
    selectToolCircle: true,
    selectToolClick: true,
    selectToolLoad: true,
    selectToolMap: true, // DEPRECATED.
    selectToolPaste: true,
    selectToolPolygon: true,
    selectToolPolyline: true,
    selectToolRadius: false, // DEPRECATED.
    selectionColor: '#ffff00', // DEPRECATED
    showTitle: true, // DEPRECATED
    singleLayerSelectionMode: true, // DEPRECATED
    toolbarAtTop: false, // DEPRECATED.
    useFeatureLimit: false,
    webmap: '',
    welcomePanelText:
        "<p>To get started, simply choose one of the tools on the left, then click and drag on the map to select features.</p><p>From there you'll be able to see aggregated reports for your selected features.</p>",
    zoomToLayer: true, // Overridden if min/max scale are set on layer.
    // Not in app-config.json.
    activeToolName: 'point',
    basemap: 'gray-vector', // Used if webmap has not been defined.
    locatorServiceUrl:
        'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
    portalUrl: 'https://www.arcgis.com' // Set hostname when using an on-premise portal (default is ArcGIS Online - https://www.arcgis.com)
};

// Handle App Config.
const useAppConfig = (config: any): any => {
    const [appConfig, setAppConfig] = useState<any>();

    // Config changed.
    useEffect(() => {
        const onAppIdChanged = async () => {
            // Read in App Config from AGOL.
            let appData: any = { values: {} };
            if (
                config.appid !== undefined &&
                config.appid !== '' &&
                config.appid !== null
            ) {
                const item = await loadPortalItem({ id: config.appid });
                appData = await item.fetchData();
            }

            let fieldFilterList = [];
            if (
                appData.values.fieldFilterList !== undefined &&
                appData.values.fieldFilterList !== null &&
                appData.values.fieldFilterList !== ''
            )
                fieldFilterList = appData.values.fieldFilterList
                    .split(',')
                    .map((item: any) => item.trim());

            setAppConfig({
                ...defaults,
                ...appData.values,
                ...config,
                fieldFilterList
            });
        };
        if (config !== undefined) onAppIdChanged();
    }, [config]);

    // App Config changed.
    useEffect(() => {
        if (appConfig !== undefined) {
            if (appConfig.portalUrl !== undefined && appConfig.portalUrl !== '')
                esriConfig.portalUrl = appConfig.portalUrl;

            if (appConfig.activeTool !== undefined) {
                const arrTools = [
                    'point',
                    'rectangle',
                    'circle',
                    'polygon',
                    'polyline'
                ];
                if (
                    appConfig.activeTool >= 0 &&
                    appConfig.activeTool < arrTools.length
                )
                    appConfig.activeToolName = arrTools[appConfig.activeTool];
            }

            // Inject CSS.
            let css = 'font-family: ';
            if (
                appConfig.fontFamily !== undefined &&
                appConfig.fontFamily !== '' &&
                appConfig.fontFamily !== 'Avenir Next'
            ) {
                if (appConfig.fontFamily !== 'work_sans_regular') {
                    WebFont.load({
                        google: {
                            families: [appConfig.fontFamily, 'sans-serif']
                        }
                    });
                }
                css += `"${appConfig.fontFamily}", `;
            }
            css += `"Avenir Next", "Helvetica Neue", Helvetica, Arial, sans-serif;`;

            if (appConfig.fontSize !== undefined && appConfig.fontSize !== '')
                css += `font-size:${appConfig.fontSize}px;`;
            if (css !== '') {
                css = `.custom-area-reporter, .modal{${css}}`;
                const head =
                    document.head || document.getElementsByTagName('head')[0];
                const style: any = document.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) style.styleSheet.cssText = css;
                else style.appendChild(document.createTextNode(css));
                head.appendChild(style);
            }
        }
    }, [appConfig]);

    return appConfig;
};
export default useAppConfig;
